import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=6eaef529&scoped=true&"
import script from "./ServiceDetail.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=6eaef529&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaef529",
  null
  
)

export default component.exports